import { render, staticRenderFns } from "./FixedNotification.vue?vue&type=template&id=703e69d4&scoped=true"
import script from "./FixedNotification.vue?vue&type=script&lang=js"
export * from "./FixedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703e69d4",
  null
  
)

export default component.exports